import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import { scrollBehavior } from '@/router/options'
import routes from '@/router/routes'
import Account from '@/api/account'
import { hasCordova } from '@/cordova'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  scrollBehavior: scrollBehavior,
  routes: routes
})

router.beforeEach(async (to, from, next) => {
  if (hasCordova && window.ga) {
    window.ga.trackView(to.name)
  }

  store.commit('setFromName', from.name)
  store.commit('addedFromRouterNames', from.name)
  if (from.name) {
    store.commit('addRecentRouteNames', from.name)
  }
  if (/(home|message|timeline|footprint\/list|mypage)/.test(to.name)) {
    store.commit('setCurrentBasePageName', to.name)
  }

  // 直近にアクセスした InfiniteScrollStore を継承した module の名前を取得する
  let moduleName = getModuleName(to.name)
  if (moduleName !== '') {
    store.commit('setFromStoreModuleName', moduleName)
  }

  const redirectToSignup =
    to.matched.some(record => record.meta.requiresAuth) && store.getters['Auth/token'].length === 0
  if (redirectToSignup) {
    // 認証必須ページに token なしでアクセスしたら signup にリダイレクト
    next({ path: '/signup' })
    store.commit('setTransitionName', 'slide-right')
  } else {
    // アクションタイムを更新
    Account.updateActionTime().catch(err => {
      console.error(err)
    })

    // 重複登録を避けるために有効なトークンを持った状態で登録ページに
    // アクセスしたならトップにリダイレクト
    const signupPage = /(signup)/.test(to.name)
    if (store.getters['Auth/token'].length > 0 && signupPage) {
      const validToken = await store.dispatch('Auth/verifyToken')
      if (validToken) {
        next({ path: '/' })
        return
      }
    }

    next()
    store.commit('setTransitionName', 'slide-right')
  }
})

window.addEventListener(
  'popstate',
  () => {
    store.commit('setTransitionName', 'slide-left')
  },
  false
)

/**
 * $route.name から Store Module の名前を取得
 */
const getModuleName = (name: string): string => {
  if (name === 'home') {
    return 'TopUser'
  } else if (name === 'search/name') {
    return 'SearchResultUser'
  } else if (name === 'message') {
    return 'MessageList'
  } else if (name === 'timeline') {
    return 'Timeline'
  } else if (name === 'footprint/list') {
    return 'Footprint'
  } else if (name === 'favlist') {
    return 'FavList'
  } else if (name === 'call/log') {
    return 'CallLog'
  }
  return ''
}

export default router
